<template>
  <div class="checkout-overlay-separator"></div>
</template>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .checkout-overlay-separator {
    border: solid 1px #1C4655;
    margin: 10px -20px;

    .checkout-overlay-expanded-content & {
      margin: 10px 0;
    }
  }
</style>

<script>
  export default {
    name: 'checkout-overlay-separator'
  }
</script>
